import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

export class GroupPicker extends PickerBase{
    static readonly JsonTypeName = "Group";
    static readonly ElementId = "Ticket.Group";
    static readonly defaultLabel = "Group";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = GroupPicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = GroupPicker.defaultLabel;

        if(GroupPicker.pickerChoices){
            this.displayChoices = GroupPicker.pickerChoices;
        }
        
        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return GroupPicker.JsonTypeName;
    }
}

export class GroupPickerPeer extends TypedCardElementPeer<GroupPicker> {
    static displayLabelProperty = getPropertyEditorInstance(GroupPicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(GroupPicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(GroupPicker.ElementId, PropertyKeys.dataSource, []);
    
    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(GroupPicker.ElementId, PropertyKeys.dataSource, choices);
    }
    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            GroupPickerPeer.idProperty,
            GroupPickerPeer.displayLabelProperty,
            GroupPickerPeer.requireFieldProperty,
            GroupPickerPeer.dataSourceProperty);
    }
}
